import styled from 'styled-components';
import { media } from 'Public/Css/media';
import { lightGrey, bgColor } from 'Public/Css/colors';

export default styled.div.attrs({ className: 'table-wrapper' })`
    .ant-table-cell {
        .actions > * {
            margin-right: 12px;
            
            &:last-child {
                margin-right: 0;
            }
        }
    }

    ${media.mobile`
        .ant-table-wrapper {
            table {
                width: 100% !important;
                display: flex;
                flex-direction: column;
                gap: 16px;

                colgroup {
                    display: none;
                }

                .ant-table-thead {
                    tr {
                        display: flex;
                        overflow: auto;

                        th {
                            &.ant-table-cell-fix-right-first {
                                display: none;
                            }

                            .ant-table-filter-column {
                                gap: 8px;
                                align-items: center;

                                .ant-table-column-sorter {
                                    margin-inline-start: 8px;
                                }

                                .ant-table-filter-trigger {
                                    padding: 8px;

                                    svg {
                                        width: 20px;
                                        height: 20px;
                                    }
                                }
                            }
                        }

                    }
                }

                .ant-table-tbody {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    background-color: ${bgColor};

                    tr {
                        display: flex;
                        flex-direction: column;
                        background: white;
                        border-radius: 8px;
                        overflow: hidden;

                        .ant-table-cell {
                            div {
                                display: flex;
                                justify-content: space-between;

                                &[data-th]:before  {
                                    content: attr(data-th);
                                    font-weight: 700;
                                }
                            }

                            .actions {
                                display: flex;
                                width: 100%;
                                justify-content: flex-end;
                                gap: 16px;
                            }

                            &.ant-table-cell-fix-right {
                                position: relative !important;
                            }

                            &:first-child {
                                background-color: ${lightGrey};

                                div {
                                    font-weight: 700;
                                    font-size: 16px;

                                    &[data-th]:before {
                                        display: none;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `}
`;
